import axios from 'axios'
import router from "@/router";
import { Message } from 'element-ui'

// 创建可一个新的axios对象
const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,   // 后端的接口地址  ip:port
    timeout: 30000                          // 30s请求超时
})

// request 拦截器
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user = JSON.parse(localStorage.getItem("xm-user") || '{}')
    config.headers['token'] = user.token

    return config
}, error => {
    console.error('request error: ' + error)
    return Promise.reject(error)
});

// response 拦截器
request.interceptors.response.use(
    response => {
        // 如果是blob类型（文件下载）
        if (response.config.responseType === 'blob') {
            // 检查响应头中是否有错误信息
            const contentType = response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                // 如果是JSON，说明后端返回了错误信息
                return response.data.text().then(text => {
                    const res = JSON.parse(text);
                    if (res.code && res.code !== '200') {
                        Message.error(res.msg || '导出失败');
                        return Promise.reject(new Error(res.msg));
                    }
                    return response;
                });
            }
            return response;
        }

        let res = response.data;
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        if (res.code === '401') {
            router.push('/login')
        }
        return res;
    },
    error => {
        console.error('response error: ' + error)
        return Promise.reject(error)
    }
)

export default request